import printHtml from '@/mixins/printHtml'

const productionWineFermentingPrint = {
  mixins: [printHtml],
  methods: {
    async printMash(id, mashBill, print) {
      const isMashBill = !!mashBill;
      const results =  await this.$apiCall(`query productionWineFermentingPrint($id:ID!, $isMashBill:Boolean!, $audit:Boolean!) {
                                              mashBill(id:$id) @include(if:$isMashBill) {
                                                name,volume,description,scalable
                                                items {itemName,itemUnits,quantity,minQuantity,maxQuantity,itemPrecision}
                                              }
                                              mash(id:$id) @skip(if:$isMashBill) {
                                                date,duration,site{name},completed
                                                mashBill{name},volume,osg,ph,lot,comments
                                                items {itemName,itemUnits,quantity,itemPrecision,lot}
                                                fermenters {fermenterName,volume}
                                                audit @include(if:$audit) {userName,time,event}
                                              }
                                              mashingPreferences {
                                                mashBrix,mashpH
                                              }
                                            }`,
                                          {id, isMashBill, audit:this.$store.getters.company.allowAudit});
      if (results.error)
        return;

      const mash = isMashBill ? results.data.mashBill : results.data.mash;
      const preferences = results.data.mashingPreferences;

      if (isMashBill && mashBill.quantity !== undefined && mash.scalable) {
        mash.items.forEach(item => {
          item.quantity =  this.$roundNumber(item.quantity * mashBill.quantity / mash.volume, item.itemPrecision);
          item.minQuantity =  this.$roundNumber(item.minQuantity * mashBill.quantity / mash.volume, item.itemPrecision);
          item.maxQuantity =  this.$roundNumber(item.maxQuantity * mashBill.quantity / mash.volume, item.itemPrecision);
        });
        mash.volume = mashBill.quantity;
      }


      const lines = [`
        <style>
          @page {size:portrait}
          table {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px;table-layout:fixed}
          td {padding:5px;height:30px;position:relative}
          .title {font-weight:bold;text-align:center;font-size:150%;padding-bottom:40px}
          .subtitle {font-weight:medium;text-align:center;height:10px}
          .box {${isMashBill ? 'border-bottom:thin solid #aaa':''}}
          .label {display:inline-block;top:-8px;position:absolute;xbackground-color:#fff;xpadding-left:5px;xpadding-right:5px;font-size:90%}
          .suffix {display:inline-block${isMashBill ? ';float:right' : ''}}
          .placeholder {${isMashBill ? 'color:#888' : ''}}
          .half-line {height:20px}
          .hint {text-align:center; font-size:9px}
          .inner-table {border:thin solid #ccc; padding:10px}
          .page-break {page-break-before: always}
          .incomplete {font-size:50px;opacity:0.2;text-align:center}
        </style>
        <table>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <thead>
            ${isMashBill || mash.completed ? '' : `<tr><td colspan="20" class="incomplete">INCOMPLETE</td></tr>`}
            <tr><td colspan="20" class="subtitle">${this.company.name}</td></tr>
            <tr><td colspan="20" class="title">Mash</td></tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5" class="box"><div class="label">Date</div>
                <span class="placeholder">
                  ${isMashBill?`${mashBill.date ? this.$formatDateTime(mashBill.date) : ''}`:this.$formatDateTime(mash.date)}
                </span>
              </td>
              <td/>
              ${this.company.settings.mashDuration ? `<td colspan="4" class="box"><div class="label">Duration</div>${isMashBill?'':this.$options.filters.duration(mash.duration)}</td>` : '<td colspan="4"/>'}
              <td colspan="4"/>
              ${this.$store.getters.sites(true, {B266:true}).length ? `<td colspan="6" class="box"><div class="label">Site</div>
                ${isMashBill?mashBill.siteName??'':mash.site.name}
              </td>` : '<td colspan="6"/>'}
            </tr>
            <tr><td colspan="20"/></tr>
            <tr>
              <td colspan="5" class="box"><div class="label">Mash bill</div>${isMashBill?mash.name:mash.mashBill.name}</td>
            </tr>
            ${mash.description ? `<tr><td colspan="10">${mash.description}</td></tr><tr><td colspan="20" class="half-line"/></tr>` : '<tr><td colspan="20"/></tr>'}
            <tr>
              <td colspan="3" class="box">
                <div class="label">Volume</div>
                <span class="placeholder">${this.$number(mash.volume,0)}</span>
                <div class="suffix">litres</div>
              </td>
              <td/>
              <td colspan="3" class="box">
              ${!preferences.mashpH ? '' :
                `<div class="label">Starting ${preferences.mashBrix?'Brix':'SG'}</div>
                  ${isMashBill?'':preferences.mashBrix?this.$number((((182.4601 * mash.osg -775.6821) * mash.osg +1262.7794) * mash.osg -669.5622), 1):this.$number(mash.osg,3)}
                `
              }
              </td>
              <td/>
              <td colspan="3" class="box"><div class="label">pH</div>${isMashBill?'':this.$number(mash.ph,1)}</td>
              <td/>
              ${isMashBill ? '' : `<td colspan="3" class="box"><div class="label">Lot</div>${mash.lot}</td>`}
            </tr>
            <tr><td colspan="20" class="half-line"/></tr>

            <tr>
              <td colspan="20" class="inner-table">
                <table>

            <tr>
              <td colspan="8" class="half-line"><strong>Mash input</strong></td>
              <td/>
              <td colspan="4" class="half-line"><strong>Lot</strong></td>
              <td/>
              <td colspan="6" class="half-line"><strong>Quantity</strong></td>
            </tr>
        `];

      for (const item of mash.items) {
        lines.push(`
          <tr>
            <td colspan="8" class="box">${item.itemName}</td>
            <td/>
            <td colspan="4" class="box">${isMashBill ? '' : item.lot ?? ''}</td>
            <td/>
            <td colspan="6" class="box">
              <span class="${item.minQuantity !== item.quantity || item.maxQuantity !== item.quantity ? 'placeholder' : ''}">${this.$number(item.quantity, item.itemPrecision)}</span>
              <div class="suffix">${item.itemUnits}</div>
            </td>
          </tr>`);
        if (isMashBill)
          lines.push(`
          <tr>
            <td colspan="14" class="half-line"/>
            <td colspan="6" class="half-line hint">
              ${!isMashBill || item.minQuantity === item.quantity && item.maxQuantity === item.quantity ? '' :
               `${item.minQuantity || item.maxQuantity ? 'Must be ' : ''}
                ${item.minQuantity ? `>= ${this.$number(item.minQuantity, item.itemPrecision)}` : ''}
                ${item.minQuantity && item.maxQuantity ? ' and ' : ''}
                ${item.maxQuantity ? `<= ${this.$number(item.maxQuantity, item.itemPrecision)}` : ''}`
              }
            </td>
          </tr>
        `);
      }
      if (isMashBill)
        lines.push(`
          <tr>
            <td colspan="8" class="box"></td>
            <td/>
            <td colspan="4" class="box"></td>
            <td/>
            <td colspan="6" class="box"></td>
          </tr>`);

      lines.push(`
          </table>
      </td>
    </tr>

        <tr><td colspan="20" class="half-line"/></tr>
        <tr>
        <td colspan="14" class="inner-table">
          <table>

        <tr>
          <td colspan="8" class="half-line"><strong>Fermenter</strong></td>
          <td/>
          <td colspan="6" class="half-line"><strong>Volume</strong></td>
        </tr>`);

      if (isMashBill)
        lines.push(`
        <tr>
          <td colspan="8" class="box"></td>
          <td/>
          <td colspan="6" class="box">
            <span class="placeholder">${this.$number(mash.volume,0)}</span>
            <div class="suffix">litres</div>
          </td>
        </tr>

        <tr><td class="half-line"/></tr>
        <tr>
          <td colspan="8" class="box"></td>
          <td/>
          <td colspan="6" class="box">
            <div class="suffix">litres</div>
          </td>
        </tr>`);

      else
        for (const fermenter of mash.fermenters)
          lines.push(`
            <tr>
            <td colspan="8" class="box">${fermenter.fermenterName}</td>
            <td/>
            <td colspan="6" class="box">
              ${this.$number(fermenter.volume,0)}
              <div class="suffix">litres</div>
            </td>
          </tr>
          `);

      lines.push(`
        </table>
      </td>
    </tr>

        <tr><td/></tr>
        <tr>
          <td colspan="20" class="box" style="height:60px"><div class="label">Comments</div>
          ${isMashBill?'':mash.comments}
          </td>
        </tr>`);

      if (isMashBill)
        lines.push(`
        <tr><td/></tr>
        <tr><td/></tr>
        <tr>
          <td colspan="8" class="box"><div class="label">Performed by</div><div class="placeholder">${mashBill.performBy}</div></td>
          <td/>
          <td colspan="8" class="box"><div class="label">Signature</div></td>
        </tr>`);

      else if (this.$store.getters.company.allowAudit) {
        lines.push(`<tr>
                      <td colspan="4"><strong>Date</strong></td>
                      <td/>
                      <td colspan="5"><strong>User</strong></td>
                      <td/>
                      <td colspan="9"><strong>Action</strong></td>
                    </tr>`);
        for (const audit of mash.audit)
          lines.push(`<tr>
                        <td colspan="4">${this.$formatDateTime(audit.time)}</td>
                        <td/>
                        <td colspan="5">${audit.userName}</td>
                        <td/>
                        <td colspan="9">${audit.event}</td>
                      </tr>`);
      }

      lines.push(`
        </tbody>
        </table>
      `);

      if (print)
        this.printHtml('Mash', lines.join(''));
      else
        return lines;
    }
  }
}

export default productionWineFermentingPrint;